import React, { Component } from 'react';
import {
  arrayOf, shape, string, func, bool,
} from 'prop-types';
import {
  Card,
  Switch,
  Paragraph,
  Icon,
} from 'components/common';
import Tooltip from 'components/common/Tooltip';
import './SwitchPanel.scss';

export default class SwitchPanel extends Component {
  static defaultProps = {
    name: {
      display: '',
      key: '',
    },
    options: [],
    onChange: null,
    notBordered: false,
    value: [],
    tooltip: shape({
      display: string,
      key: string,
    }),
  };

  static propTypes = {
    name: shape({
      display: string,
      key: string,
    }),
    options: arrayOf(shape({
      name: string,
      id: string,
    })),
    value: arrayOf(string),
    queryParam: string.isRequired,
    onChange: func,
    notBordered: bool,
    tooltip: {
      display: '',
      key: '',
    },
  };

  constructor(props) {
    super(props);
    this.handleSwitchToggle = this.handleSwitchToggle.bind(this);
  }

  generateSwitchList = (options, value) => (
    options.map((item) => {
      const selected = (value || []).includes(item.name);
      return (
        <Switch
          key={item.name + (selected ? '1' : '0')}
          id={item.name}
          onChange={this.handleSwitchToggle}
          selected={selected}
        >
          {item.value}
        </Switch>
      );
    })
  );

  handleSwitchToggle(id, active) {
    const { value, onChange, queryParam } = this.props;
    if (onChange) {
      onChange({
        value: (active) ? [...(value || []), id] : (value || []).filter(item => item !== id),
        queryParam,
      });
    }
  }

  render() {
    const {
      name: { display },
      notBordered,
      value,
      options,
      queryParam,
      tooltip,
    } = this.props;
    return (
      <Card.Content notBordered={notBordered} className="switch-panel" dataSelectorId={queryParam}>
        <Paragraph bold>
          {display}
        </Paragraph>
        {this.generateSwitchList(options, value, queryParam)}
        {tooltip.display && (
          <Tooltip id="switch-panel-info" text={tooltip.display} position="top">
            <Icon name="info" secondary small />
          </Tooltip>
        )}
      </Card.Content>
    );
  }
}
